import App from './App';
import React from 'react';
import './styles/index.scss';
import ReactDOM from 'react-dom';
import * as ServiceWorker from './service';

ReactDOM.render(<App/>, document.getElementById('root'));

ServiceWorker.unregister();
